import React from "react";

const TableHead = ({ hasExternalOrder }) => (
  <thead className="thead-light">
    <tr>
      <th scope="col">Protocolo</th>
      {hasExternalOrder && <th scope="col">N. Pedido</th>}
      {!hasExternalOrder && <th scope="col">Placa</th>}
      {!hasExternalOrder && <th scope="col">Renavam</th>}
      <th scope="col">Valor s/ Juros</th>
      <th scope="col">Valor c/ Juros</th>
      <th scope="col">Valor Ajustado</th>
      <th scope="col">Valor Agregado</th>
      <th scope="col">Estabelecimento</th>
      <th scope="col">Status</th>
      <th scope="col">Data criação</th>
      <th scope="col">Data atualizaçao</th>
      <th scope="col"></th>
    </tr>
  </thead>
);

export default TableHead;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/TableHead.js